import React, { useState, useEffect } from "react";
import "./styles/WebLandingPage.css";
import WebLandingPage from "./components/WebLandingPage"
import MobileWebLandingPage from "./components/MobileWebLandingPage";

function App() {

    const [isMobile, setIsMobile] = useState(false);

    const determineIfMobile = () => {
      setIsMobile((window.innerWidth < 1150));
    };

    useEffect(() => {
      determineIfMobile();
    });

    useEffect(() => {
      window.addEventListener("resize", determineIfMobile);
      return () => {
        window.removeEventListener("resize", determineIfMobile);
      };
    }, []);

    return (<>
        {(isMobile)
          ? <MobileWebLandingPage/>
          : <WebLandingPage /> }
      </>);
}

export default App;
